module.exports = __webpack_public_path__ + "img/14m.db9fb356.jpg";